import styled from 'styled-components';

export const RadioGroupWrapperStyled = styled.div`
  padding: 2rem 0;
`;
